import { call, put } from "redux-saga/effects";
import { postLoanForm } from "../../services/applicationFormApi";
import { WENT_WRONG_MESSAGE } from "../../constants/commonMessage";
import { EZIDEBIT_PAYMENT_FIELDS, FIELD_NAMES } from "../../constants/commonConstants";
import {
  convertStringToAmountInCents,
  convertStringToFloatAddContractualPayment,
} from "../../utils/helpers/math";

export function* submitForm(endpoint, loanFormValues, actions) {
  try {
    const response = yield call(postLoanForm, endpoint, loanFormValues);
    const { status } = response;

    switch (status) {
      case 200:
        yield put(actions.postLoanFormSuccess());
        break;
      default: {
        yield put(
          actions.postLoanFormError({ errMessage: WENT_WRONG_MESSAGE })
        );
      }
    }
  } catch (error) {
    yield put(
      actions.postLoanFormError({
        errMessage: error.message || WENT_WRONG_MESSAGE
      })
    );
  }
}

export function* submitFormManageRepayments(endpoint, loanFormValues, actions, formId) {
  let formattedPayloadValues;
  const contractedPaymentRegularValue = loanFormValues[FIELD_NAMES.CONTRACTUAL_PAYMENT_REGULAR] || 0;
  switch (formId) {
    case ("increase-repayments-form"):
      formattedPayloadValues = convertStringToFloatAddContractualPayment(
        loanFormValues,
        FIELD_NAMES.PAYMENT_VALUE,
        contractedPaymentRegularValue
      );
      break;
    case ("pay-today-form"):
      formattedPayloadValues = convertStringToAmountInCents(
        loanFormValues,
        EZIDEBIT_PAYMENT_FIELDS.AMOUNT_IN_CENTS
      );
      break;
    default:
      formattedPayloadValues = loanFormValues;
      break;
  }

  try {
    const response = yield call(postLoanForm, endpoint, formattedPayloadValues);
    const { status, data } = response;

    switch (status) {
      case 200:
        yield put(actions.postLoanFormSuccess());
        if (data.value.bankReceiptId !== "") {
          yield put(
            actions.setEzidebitPaymentResponse(data.value.bankReceiptId)
          );
        }

        if (data.value.paymentResultText) {
          if(data.value.paymentResultText !== "APPROVED") {
            yield put(
              actions.postLoanFormError({ errMessage: WENT_WRONG_MESSAGE })
            );
          };
        }
        break;
      default: {
        yield put(
          actions.postLoanFormError({ errMessage: WENT_WRONG_MESSAGE })
        );
      }
    }
  } catch (error) {
    yield put(
      actions.postLoanFormError({
        errMessage: error.message || WENT_WRONG_MESSAGE,
      })
    );
  }
}
